import { Theme, makeStyles } from '@material-ui/core';

const styles: any = (theme: Theme | any) => ({
});

export default makeStyles(styles);
